import PropTypes from 'prop-types';
import React from 'react';
import { Component as ComponentType } from './types';
import { ComponentStatuses as ComponentStatusesType } from './types';

const cx = require('classnames');

const ComponentStatusSelector = require('components/manage/pages/components/component_status_selector');

class ComponentRow extends React.Component {

  static propTypes = {
    currentStatus: PropTypes.string,
    component: ComponentType.isRequired,
    componentStatuses: ComponentStatusesType.isRequired,
    informParent: PropTypes.func,
    isChild: PropTypes.bool,
    isGroupParent: PropTypes.bool,
    pageParam: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    shouldAutoUpdate: PropTypes.bool.isRequired,
    toggleOverridden: PropTypes.func,
    visible: PropTypes.bool,
  };

  static defaultProps = {
    informParent: new Function(),
    isChild: false,
    isGroupParent: false,
    onClick: undefined,
    toggleOverridden: new Function(),
    visible: false,
    currentStatus: null,
  };

  _displayToggleIcon () {
    let classNames = 'fa group-parent-indicator';
    classNames = this.props.visible ? cx(classNames, 'fa-minus-square-o') : cx(classNames, 'fa-plus-square-o');

    return <span className={classNames} onClick={this.props.onClick} />;
  }

  _displayThirdPartyLogo () {
    return <img className="logo" src={this.props.component.logo_url} alt={this.props.component.name} />;
  }

  _displayStatusSelector () {
    return (<ComponentStatusSelector
      pageParam={this.props.pageParam}
      currentStatus={this.props.currentStatus}
      component={this.props.component}
      componentStatuses={this.props.componentStatuses}
      isGroupParent={this.props.isGroupParent}
      isChild={this.props.isChild}
      informParent={this.props.informParent}
      toggleOverridden={this.props.toggleOverridden}
      shouldAutoUpdate={this.props.shouldAutoUpdate} />);
  }

  render () {
    return (
      <div className="table-row component-row">
        { this.props.isGroupParent ? this._displayToggleIcon() : null }
        { this.props.component.is_third_party ? this._displayThirdPartyLogo() : null }
        <div className="component-name">
          { this.props.component.name }
        </div>
        {this._displayStatusSelector() }
        <div className="clearfix" />
      </div>
    );
  }
}

module.exports = ComponentRow;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/component_row.jsx